import * as React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

export default function Mission() {
  return (
    <Container
      id="mission"
      sx={{
        pt: { xs: 2, sm: 4 },
        pb: { xs: 4, sm: 8 },
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 2, sm: 4 },
      }}
    >
      <Typography
        component="h2"
        variant="h4"
        sx={{ color: 'text.primary', mb: 1 }}
      >
        Mission
      </Typography>
      <Typography
        variant="body1"
        sx={{ color: 'text.secondary', width: { sm: '100%', md: '80%' }, textAlign: 'center', mb: 1 }}
      >
        Medskool.org brings course reviews, a vibrant community forum, tutoring services,
        and listings for research and clinical opportunities together in one place.
        Our goal is to simplify every step of the premedical journey so students
        can focus on learning and connecting with peers who share the dream of
        becoming physicians.
      </Typography>
      <Typography
        variant="body1"
        sx={{ color: 'text.secondary', width: { sm: '100%', md: '80%' }, textAlign: 'center' }}
      >
        This project was created by students who understand how daunting and competitive the path can be.
        Resources are often scattered, and not everyone has equal access. Our aim is to unite people and knowledge
        within each institution's community. We believe collaboration and helping others is powerful. We're not
        trying to replace big forums like Reddit or SDN—we're filling the gap where students need a place to share
        honest thoughts while keeping their identities private.
      </Typography>
    </Container>
  );
}
